import "./Navbar.css";
import { useContext, useEffect, useState, useRef, } from "react";
import { NavLink } from "react-router-dom";
import styled from "@emotion/styled";

import CookieContext from "../contexts/CookieContext";

const NavButton = styled.button`
  width: 150px;
  color: ${({ active }) => (active ? "#ffffff" : "darkgray")};
  background: ${({ active }) => active
      ? "linear-gradient(180deg, #000099, #0033ff)"
      : "linear-gradient(180deg, #100c08, #000099)"};
  background: ${({ disabled }) => disabled &&
      "linear-gradient(180deg, #666666, #999999)"};
`;


const navs = ["", "AutoRefresh", "List", "ActionState", "Optimistic", "OptimisticUpdate", "Iine",
  "Chat", "WorkTimeTracker", "Item", "Checklist", "Checklist2", "Checklist3",
  "Cookie", "Roulette", "React19", "Point", "About", "Contact", "LinkCollection", "MyPage", ]
const navsJ = ["ホーム", "自動更新", "List", "ActionState", "Optimistic", "OptiUpdate", "いいね！",
  "チャット", "作業時間管理", "アイテム", "チェックリスト", "チェックリスト2", "チェックリスト3",
  "Cookie", "ルーレット", "React19", "ポイント", "アバウト", "連絡先", "Link集", "マイページ", ];

const Navbar = () => {
  const [active, setActive] = useState(navs[0]);
  const { cookies, setJwtCookies, refreshJwtCookies, removeJwtCookies } = useContext(CookieContext);
  // ボタンの有効化/無効化の管理
  const [disabled, setDisabled] = useState(false);

  const jwtCheck = async (data) => {

    if (!cookies.jwtAccess) {
      // ボタンを無効化
      setDisabled(true);
    }
    try {
      // const res = await axios
      //   .post(
      //     // `https://api2.wacha.biz/device/register/`,
      //     `${apiHost}device/register/`,
      //     {
      //       // device_uuid: data.device_uuid,
      //       // password: data.password,
      //       // password: 'dummy',
      //     },
      //     {
      //       headers: { "Content-Type": "application/json" },
      //     }
      //   )

      // // 作成したdevice_uuidとmanagement_cdでログイン
      // onLogin(res.data.device_uuid, res.data.management_cd);
    } catch (e) {
    } finally {
    }
  }

  // 初回アクセス時に一度だけ実行
  useEffect(() => {
    jwtCheck();
  }, []);
  

  return (
    <>
      {navs.map((nav, index) => {
        return (
          <span key={index}>
            <NavLink to={nav}>
              <NavButton
                key={nav}
                disabled={disabled}
                active={active === nav ? +true : +false}
                onClick={() => setActive(nav)}
              >
                {navsJ[index]}
              </NavButton>
            </NavLink>
          </span>
        );
      })}
    </>
  );
};

export default Navbar;
